// Ported from design/project/App55-DepositPending.dc.html, then wired: waits for the indexer's "deposit" event.
import { useEffect } from "react";
import { usdt } from "@degenduel/shared";
import { fit } from "../fit.js";
import { lastDeposit, moneyChanged, useMoney, walletName } from "../money.js";
import { go } from "../router.js";

/** What the Deposit screens left for this one: the amount (unknown when sent from outside) and the wallet. */
function pending(): { amount: string | null; at: number; from: string | null } {
  try {
    return JSON.parse(sessionStorage.getItem("dd:pendingDeposit") ?? "") as { amount: string | null; at: number; from: string | null };
  } catch {
    return { amount: null, at: Date.now(), from: null };
  }
}

export function App55_DepositPending() {
  const p = pending();
  const fromApp = p.amount !== null;
  const { view, reload } = useMoney();
  useEffect(() => {
    // It may already have landed while the wallet app was still open, before this screen was shown.
    if (lastDeposit && lastDeposit.at >= p.at) return void go("App70", true);
    const on = (e: Event) => {
      if ((e as CustomEvent).detail) go("App70", true);
    };
    addEventListener("dd:money", on);
    // The live message can be missed when the phone sleeps or switches apps, so the balance is also checked.
    const poll = setInterval(() => void reload(), 5000);
    return () => {
      removeEventListener("dd:money", on);
      clearInterval(poll);
    };
  }, []);
  useEffect(() => {
    if (!view) return;
    const since = p.at + (view.serverTime - view.fetchedAt) - 5000;
    const landed = view.activity.find((a) => a.kind === "deposit" && a.state === "credited" && a.at >= since);
    if (landed) moneyChanged({ type: "deposit", credited: usdt(landed.amount.replace(/,/g, "")).toString(), returned: "0", at: Date.now() });
  }, [view]);
  const signedAt = new Date(p.at).toLocaleTimeString("en-GB");

  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "40px", left: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "44px" }}>
    <div className="top"><span className="syne" style={{ fontWeight: "800", fontSize: "17px" }}>Deposit</span></div>
    <div style={{ marginTop: fit(4, 14), alignSelf: "center", position: "relative", width: fit(140, 180), height: fit(140, 180) }}>
      <svg width="100%" height="100%" viewBox="0 0 180 180" style={{ display: "block", animation: "ddSpin 2.4s linear infinite" }} aria-hidden="true"><circle cx="90" cy="90" r="80" fill="none" stroke="#30363D" strokeWidth="6"></circle><path d="M90 10 A80 80 0 0 1 170 90" fill="none" stroke="#CCFF00" strokeWidth="6" strokeLinecap="round"></path></svg>
      <div style={{ position: "absolute", inset: "0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}><span className="mono" style={{ fontWeight: "800", fontSize: "32px" }}>{p.amount ? Number(p.amount).toFixed(2) : "USDT"}</span>{p.amount && <span className="muted" style={{ fontSize: "12px" }}>USDT</span>}</div>
    </div>
    <h1 className="h1" style={{ marginTop: fit(10, 18), textAlign: "center" }}>{fromApp ? "Deposit on the way" : "Waiting for your deposit"}</h1>
    <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>{fromApp ? "Usually about 10 seconds." : "It lands about a minute after it's sent."} You can keep browsing, it shows in your balance as soon as it lands.</p>
    <div className="g" style={{ marginTop: fit(12, 20), borderRadius: "20px", padding: "4px 0" }}>
      <div className="li"><svg width="20" height="20" viewBox="0 0 24 24" style={{ flex: "none" }} aria-hidden="true"><circle cx="12" cy="12" r="10" fill="#CCFF00"></circle><path d="M7 12.5 L10.5 16 L17 9" stroke="#0B0E14" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg><span style={{ flex: "1", fontSize: "14px" }}>{fromApp ? `Signed in ${walletName(p.from)}` : "Sent from @wallet or an exchange"}</span><span className="mono muted" style={{ fontSize: "12px" }}>{signedAt}</span></div>
      <div className="div" style={{ margin: "0 14px" }}></div>
      <div className="li"><svg width="20" height="20" viewBox="0 0 24 24" style={{ flex: "none", animation: "ddSpin 1s linear infinite" }} aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="#30363D" strokeWidth="3"></circle><path d="M12 3 A9 9 0 0 1 21 12" fill="none" stroke="#CCFF00" strokeWidth="3" strokeLinecap="round"></path></svg><span style={{ flex: "1", fontSize: "14px" }}>Confirming on TON</span><span className="mono lime" style={{ fontSize: "12px" }}>LIVE</span></div>
      <div className="div" style={{ margin: "0 14px" }}></div>
      <div className="li"><span style={{ width: "20px", height: "20px", flex: "none", borderRadius: "50%", border: "2px solid #30363D", boxSizing: "border-box" }}></span><span className="muted" style={{ flex: "1", fontSize: "14px" }}>Added to battle balance</span><span className="mono muted" style={{ fontSize: "12px" }}>NEXT</span></div>
    </div>
    <div style={{ marginTop: "auto", paddingTop: "12px" }}><button onClick={() => go("App09", true)} className="btnS" style={{ width: "100%", cursor: "pointer" }}>Keep browsing</button></div>
  </div>
</div>
    </>
  );
}
